<!-- eslint-disable prettier/prettier -->
<mat-card-header class="flex align-items-center">
  <shared-title>{{ operation }} Nivel</shared-title>
  <button
    mat-icon-button
    matTooltip="Limpiar formulario"
    matTooltipPosition="right"
    class="ml-5"
    (click)="clearForm()">
    <mat-icon>cleaning_services</mat-icon>
  </button>
</mat-card-header>
<form [formGroup]="floorForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content class="grid">
    <div
      class="grid flex-grow flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <div class="col-12 flex-grow sm:col-12 md:col-8 lg:col-8 xl:col-8">
        <shared-input
          class="w-full"
          [labelTitle]="'Nombre'"
          type="text"
          [control]="$any(floorForm.get('name'))" />
      </div>
      <div
        class="col-12 -flex-grow text-center sm:col-12 md:col-4 lg:col-4 xl:col-4">
        <div class="text-lg">Edificio:</div>
        <div class="text-3xl font-bold">{{ currentBuilding.name }}</div>
        <div class="hidden">
          <input
            formControlName="buildingid"
            [value]="currentBuilding.buildingid" />
        </div>
      </div>

      <div
        class="col-12 flex-grow text-center sm:text-center md:text-left lg:text-left xl:text-left sm:col-12 md:col-4 lg:col-4 xl:col-4">
        <mat-checkbox formControlName="isParking">¿Es parqueo?</mat-checkbox>
      </div>

      <div class="col-12 text-center sm:col-12 md:col-4 lg:col-4 xl:col-4">
        <button type="button" mat-raised-button (click)="fileInput.click()">
          Seleccionar mapa
        </button>
        <input
          hidden
          (change)="loadBase64Image($event)"
          #fileInput
          type="file"
          name="planoFloor"
          id="planoFloor" />
      </div>

      <div
        class="col-12 flex-grow text-center sm:col-12 md:col-4 lg:col-4 xl:col-4">
        @if (planoBase64) {
          <img [src]="planoBase64" alt="" height="100px" />
        }
        <input class="hidden" formControlName="imagemap" />
      </div>
    </div>
    <shared-text-area
      labelTitle="Descripción"
      [control]="$any(floorForm.get('description'))" />
  </mat-dialog-content>
  <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
    <shared-button
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'"
      >Cancelar
    </shared-button>
    <shared-button
      [disabled]="!floorForm.valid"
      [icon]="'save_alt'"
      [typeBtn]="'submit'"
      [color]="'accent'">
      Guardar
    </shared-button>
  </mat-dialog-actions>
  <mat-accordion>
    <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)">
      <mat-expansion-panel-header>
        <mat-panel-title> Observación </mat-panel-title>
      </mat-expansion-panel-header>
      <p>
        {{ messageHelpPassword() }}
      </p>
    </mat-expansion-panel>
  </mat-accordion>
</form>
